import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import NiotaClassicApiService from '@/services/niotaClassicApiService';

export default {
  data() {
    return {
      accountFilterReady: false,
      selectedAccounts: [],

      searchItems: [],
      searchGroups: [],
      searchTags: [],
      deviceTypes: [],
      loadingData: {
        deviceGroups: false,
        deviceTypes: false,
        tags: false,
      },
    };
  },
  computed: {
    ...mapState('app', ['language']),
    loadingDataDone() {
      return Object.values(this.loadingData).every((value) => value);
    },
    searchTypes() {
      return [
        {
          text: this.$t('Common.id'),
          param: 'logId',
        },
        {
          text: this.$t('AlarmLogs.search.message'),
          param: 'message',
        },
        {
          text: this.$t('AlarmLogs.search.deviceId'),
          param: 'virtualDeviceId',
        },
        {
          text: this.$t('AlarmLogs.search.logCategory'),
          param: 'logCategory',
          items: [],
          combobox: true,
        },
        {
          text: this.$t('AlarmLogs.search.operationalStatus'),
          param: 'virtualDeviceOperationalStatus',
          items: [],
          combobox: true,
        },
        {
          text: this.$t('AlarmLogs.search.group'),
          param: 'virtualDeviceGroups',
          items: [],
        },
        {
          text: this.$t('AlarmLogs.search.tag'),
          param: 'tags',
          items: [],
        },
        {
          text: this.$t('AlarmLogs.search.status'),
          param: 'isResolved',
          items: [],
        },
      ];
    },
    resolvedState() {
      return [
        { text: this.$t('AlarmLogs.search.resolved'), value: true },
        { text: this.$t('AlarmLogs.search.unresolved'), value: false },
      ];
    },
    operationalStatus() {
      return {
        0: this.$t('NiotaClassic.Devices.form.unset'),
        1: this.$t('NiotaClassic.Devices.form.inTransit'),
        2: this.$t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$t('NiotaClassic.Devices.form.inOperation'),
        4: this.$t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$t('NiotaClassic.Devices.form.decommissioned'),
      };
    },
    operationalStatusItems() {
      return Object.keys(this.operationalStatus).map((status) => {
        return { text: this.operationalStatus[status], value: status };
      });
    },
    logCategories() {
      return [
        { text: this.$t('AlarmLogs.categories.connectivity'), value: 'connectivity' },
        { text: this.$t('AlarmLogs.categories.battery'), value: 'battery' },
        { text: this.$t('AlarmLogs.categories.device'), value: 'device' },
        { text: this.$t('AlarmLogs.categories.packet-threshold'), value: 'packet-threshold' },
      ];
    },
  },
  watch: {
    language() {
      (
        this.searchTypes.find((item) => item.param === 'virtualDeviceOperationalStatus') || {}
      ).items = this.operationalStatusItems;
      (this.searchTypes.find((item) => item.param === 'logCategory') || {}).items = this.logCategories;
      (this.searchTypes.find((item) => item.param === 'health') || {}).items = this.healthStatusItems;
      (this.searchTypes.find((item) => item.param === 'virtualDeviceGroups') || {}).items = this.searchGroups;
      (this.searchTypes.find((item) => item.param === 'tags') || {}).items = this.searchTags;
      (this.searchTypes.find((item) => item.param === 'deviceType') || {}).items = this.deviceTypes;
      (this.searchTypes.find((item) => item.param === 'isResolved') || {}).items = this.resolvedState;
    },
  },
  methods: {
    fetchDeviceGroups() {
      ApiService.virtualDeviceFetchGroups(this, null) // fetch groups for all accounts (hopefully only those the user has access to)
        .then((result) => {
          this.searchGroups = result.groupList;
          (this.searchTypes.find((item) => item.param === 'virtualDeviceGroups') || []).items = result.groupList;
          this.loadingData.deviceGroups = true;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    resetLoadingData() {
      for (const key in this.loadingData) {
        this.loadingData[key] = false;
      }
    },
    getMultiFilterData() {
      this.resetLoadingData();

      (
        this.searchTypes.find((item) => item.param === 'virtualDeviceOperationalStatus') || {}
      ).items = this.operationalStatusItems;
      (this.searchTypes.find((item) => item.param === 'logCategory') || {}).items = this.logCategories;
      (this.searchTypes.find((item) => item.param === 'health') || {}).items = this.healthStatusItems;
      (this.searchTypes.find((item) => item.param === 'isResolved') || {}).items = this.resolvedState;

      this.fetchDeviceGroups();
      NiotaClassicApiService.deviceTypesGetPlain()
        .then((res) => {
          this.deviceTypes = res.data.devicetypes.map((dt) => {
            return { value: dt.id, text: dt.title, id: dt.id };
          });

          (this.searchTypes.find((item) => item.param === 'deviceType') || {}).items = this.deviceTypes;

          this.loadingData.deviceTypes = true;
        })
        .catch((error) => {
          this.snack(this.$t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
          console.error(error);
        });

      ApiService.virtualDeviceFetchTagsAndZones()
        .then((result) => {
          this.searchTags = result.tagList;
          (this.searchTypes.find((item) => item.param === 'tags') || []).items = result.tagList;
          (this.searchTypes.find((item) => item.param === 'zone') || []).items = result.zoneList;

          this.loadingData.tags = true;
          this.loadingData.zones = true;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
